/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetUsersResponseData,
  GetUsersResponseDataFromJSON,
  GetUsersResponseDataFromJSONTyped,
  GetUsersResponseDataToJSON
} from './GetUsersResponseData'

/**
 *
 * @export
 * @interface GetUsersResponse
 */
export interface GetUsersResponse {
  /**
   *
   * @type {number}
   * @memberof GetUsersResponse
   */
  status?: number
  /**
   *
   * @type {GetUsersResponseData}
   * @memberof GetUsersResponse
   */
  data?: GetUsersResponseData
}

export function GetUsersResponseFromJSON(json: any): GetUsersResponse {
  return GetUsersResponseFromJSONTyped(json, false)
}

export function GetUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetUsersResponseDataFromJSON(json['data'])
  }
}

export function GetUsersResponseToJSON(value?: GetUsersResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetUsersResponseDataToJSON(value.data)
  }
}
